<script setup>
	import { ref } from 'vue'
	import { event } from 'vue-gtag'

	//binding to invoke method on child componenet
	//const childRefMediaModal = ref({})

	const emit = defineEmits(['close'])
	const props = defineProps({
		isOpen: {
			type: Boolean,
			default: false,
		},
		source: {
			type: String,
			required: true
		},
		poster: {
			type: String,
			required: true
		}
	})

	function closeMediaModal() {
		emit('closeMediaModal');
	}
	
	const handlePlay = () => {
		// Listen for the 'play' event add ga event
		event('video_start', {
				'video_title': props.source.split('/').pop(), // Extracts filename as title
				'video_url': props.source,
				'video_provider': 'html5'
			});
	};

	defineExpose({
		//openModal
	});

</script>

<template>
	<div v-if="props.isOpen" class="modal-overlay">
		<div class="modal-container">
			<div class="modal-header">
				About S&E Indicators
				<button class="btn-icon btn-close" @click="closeMediaModal" title="close media" aria-label="close media"><i class="fa-solid fa-times"></i></button>
			</div>
			<div class="modal-body">
				<div id="media-container" class="media-container">
					<video controls
						width="100%"
						:src="props.source"
						:poster="props.poster"
						@play="handlePlay"
						>
						Your browser does not support HTML video.
					</video>
				</div>
			</div>
		</div>
	</div>
</template>
   
  <style scoped>
  .modal-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index:100
  }
  
  .modal-container {
	background-color: var(--surface-color-Default);
	display: flex;
	max-width: 48.25rem;
	/*min-height: 24rem;*/
	padding: var(--spacing-0, 0rem);
	flex-direction: column;
	align-items: flex-start;
	/*gap: var(--spacing-3xl, 2.5rem);*/
	position: relative;
	z-index: 101;
    border-top-left-radius: var(--radius-xl);
    border-top-right-radius: var(--radius-xl);
    border-bottom-left-radius: var(--radius-xl);
    border-bottom-right-radius: var(--radius-xl);		
  }
  
  .modal-header {
	display: flex;
	height: 5rem;
	padding: 1.4375rem 2rem 1.5625rem 2rem;
	justify-content: space-between;
	align-items: center;
	align-self: stretch;
	border-bottom: 1px solid var(--borders-DividerActive, #064291);
	background: var(--surface-brand-Blue, #064291);
	color: var(--text-Inverse, #fff);
	font-family: var(--font-family-Title);
	font-size: var(--font-size-H5);
    border-top-left-radius: var(--radius-xl);
    border-top-right-radius: var(--radius-xl);	
  }
  
  .modal-body {
	background: var(--surface-Default, #FFF);
	/*min-height: 12rem;*/
	display: flex;
	/*padding: 0rem var(--spacing-xl, 1.5rem) var(--spacing-xl, 6rem) var(--spacing-xl, 1.5rem);*/
	padding: var(--spacing-0, 0rem);
	flex-direction: column;
	align-items: flex-start;
	/*gap: var(--spacing-xl, 1.5rem);*/
	align-self: stretch;	
  }
  
  .modal-footer {
	display: flex;
	padding: var(--spacing-lg, 1rem) var(--spacing-xl, 1.5rem);
	justify-content: flex-end;
	align-items: flex-end;
	gap: var(--spacing-lg, 1rem);
	align-self: stretch;
	max-height: 5rem;

	border-top: 1px solid var(--border-color-Divider, #A9B7C7);
	background: var(--surface-default, #FFF);
    border-bottom-left-radius: var(--radius-xl);
    border-bottom-right-radius: var(--radius-xl);		
  }

  .title {
	color: var(--text-Primary, #2C2C2C);
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 1rem);
	font-style: normal;
	font-weight: 400;
	line-height: var(--font-line-height-Base, 1.5rem); /* 150% */
	display: block;
  }

  .sub-title {
	color: var(--text-secondary, #757575);
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 1rem);
	font-style: normal;
	font-weight: 400;
	line-height: var(--font-line-height-Base, 1.5rem); /* 150% */
  }
  video {
	/*width: 718px;*/
	display: block;
	width: 100%;
	/*margin-bottom: -8px;*/
	object-fit: cover;
  }
  .media-container {
	/*width: 45rem; */
	/*width: 100%;*/
	border: 1px solid var(--border-color-Divider);	
	margin: 1rem;
  }

  .btn-close {
	width: 1rem;
	color: var(--icons-icon-cta-reverse, #FFF);
	background: var(--surface-brand-Blue, #064291);
	font-size: 1.25rem;
	font-style: normal;
	font-weight: 900;
	line-height: normal;
	border: 0;
  }

  .btn {
    height: 3rem;
    min-width: 5rem;
    min-height: 2.5rem;
    padding: 0.75rem 0.5rem;
    border-radius: 0.5rem;
    font-family: var(--font-family-Title, Roboto);
    font-size: var(--font-size-Base, 1rem);
    font-style: normal;
    font-weight: 500;
    line-height: var(--font-line-height-Base, 1.5rem);
  }

	/* 767px - mobile */
	@media (max-width: 47.9375rem) {
		.media-container video {
			min-width: 10rem;
			width: 100%;
			height: auto;
		}
	}
   
  </style>